import React from 'react';
import { Form, Input, Select } from 'antd'

import formItemLayout from 'components/Portal/formItemLayout';

class OtherSelect extends React.Component {
	state = {
		otherText: ''
	}
	handleSelectChange = (newValue) => {
		let v = {};
		v[this.props.name] = newValue;
		this.props.form.setFieldsValue(v);
	}
	handleInputChange = (e) => {
		this.setState({ otherText: e.target.value });
		let v = {};
		if (e.target.value === '') v[this.props.name] = 'Other';
		else v[this.props.name] = 'Other: ' + e.target.value;
		this.props.form.setFieldsValue(v);
	}
	handleProps = (props) => {
        const value = props.form.getFieldValue(props.name);
		this.setState({
			otherText: (value && value.split(': ').length > 1)? value.split(': ').slice(1).join(': '): ''
		});
	}
	componentWillReceiveProps(nextProps) { this.handleProps(nextProps); }
	componentDidMount() { this.handleProps(this.props); }
	render() {
		const { getFieldDecorator } = this.props.form;
        const { name, label, help, disabled, required, options, value } = this.props;
        const selectValue = (typeof(value) === 'string')? value.split(': ')[0]: null;
        const otherText = (value && value.split(': ').length > 1)? value.split(': ').slice(1).join(': '): '';
		return (
			<span>
				<Form.Item label={label} help={help} {...formItemLayout}>
					{getFieldDecorator('select', {
						initialValue: selectValue,
						hidden: true,
						rules: (required)? [{required:true}]: []
					})(
						<Select onChange={this.handleSelectChange} disabled={disabled}>
							{options.concat(['Other']).map(value => {
								return <Select.Option key={value}>{value}</Select.Option>
							})}
						</Select>
					)}
					{this.props.form.getFieldValue(name) && this.props.form.getFieldValue(name).substring(0,5) === 'Other' &&
                        <Input
                            disabled={disabled}
                            placeholder="Please specify"
                            defaultValue={otherText}
                            onChange={this.handleInputChange} />
                    }
				</Form.Item>
				<Form.Item>
					{getFieldDecorator(name, {
						initialValue: this.props.value
					})(
						<Input type="hidden" />
					)}
				</Form.Item>
			</span>
		);
	}
}

module.exports = OtherSelect;



// WEBPACK FOOTER //
// ./portal-components/OtherSelect/index.jsx